export default "__VITE_ASSET__BV17_dNb__"